/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VirtualHealthLibraryStrictHttpResponse } from '../../virtual-health-library-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaQueryRequest } from '../../models/media-query-request';
import { MiniAiChatQueryResponse } from '../../models/mini-ai-chat-query-response';

export interface AiMiniAiChatQueryPost$Params {
      body?: MediaQueryRequest
}

export function aiMiniAiChatQueryPost(http: HttpClient, rootUrl: string, params?: AiMiniAiChatQueryPost$Params, context?: HttpContext): Observable<VirtualHealthLibraryStrictHttpResponse<MiniAiChatQueryResponse>> {
  const rb = new RequestBuilder(rootUrl, aiMiniAiChatQueryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VirtualHealthLibraryStrictHttpResponse<MiniAiChatQueryResponse>;
    })
  );
}

aiMiniAiChatQueryPost.PATH = '/AI/MiniAiChatQuery';
